import axios from "axios";
import API_CONFIG from "../config/api.config";

/**
 * Create axios instance with default configuration
 */
const mainClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

/**
 * Create additional axios instances for different base URLs
 */
export const stockApiClient = axios.create({
  baseURL: API_CONFIG.STOCK_BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

export const pdfApiClient = axios.create({
  baseURL: API_CONFIG.PDF_BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

export default mainClient;
